// export const API_URL = 'http://localhost:3000';
export const API_URL = 'https://website-clement-dubois.oa.r.appspot.com'

// Passer à true une fois le CORS du bucket configuré (backend/gcs-cors.json) :
// active la couleur automatique (claire/foncée) de la légende de l'image d'accueil
export const MEDIA_CORS_ENABLED = false
